import type { BuildingGraphNode } from "@eisox/api/core-api";
import dayjs, { type ConfigType, type Dayjs } from "@eisox/dayjs";

import {
  ELEMENT_SUBTYPE_LABELS,
  ENTITY_TYPE_LABELS,
  GENERATED_NAME_PATTERN,
  HOUSE_MAX_DURATION_PRESENCE_DETECTION,
} from "~/constants/building.constant";

/**
 * Checks if presence was recently detected in a house.
 * @param house - The house object to check.
 * @param date - The current date.
 * @returns A boolean indicating whether presence was recently detected.
 */
export const isPresenceRecentlyDetected = (lastPresenceDetected: ConfigType, date: Dayjs) =>
  !!lastPresenceDetected &&
  dayjs(date).diff(dayjs(lastPresenceDetected), "millisecond") <= HOUSE_MAX_DURATION_PRESENCE_DETECTION;

export const elementName = ({ name, type, subtype }: BuildingGraphNode): string => {
  if (name && !GENERATED_NAME_PATTERN.test(name)) return name;
  return (subtype && ELEMENT_SUBTYPE_LABELS[subtype]?.()) ?? ENTITY_TYPE_LABELS[type]();
};
